import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const getCustomFields = async (_id?: string): Promise<AxiosResponse> => {
  if (_id) {
    return AxiosInstance.get(`livechat/custom-fields/${_id}`);
  }
  return AxiosInstance.get('livechat/custom-fields');
};
